//
import headers from './headersDetail'
//-
export default [
    {
        name: 'id',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'N°',
        },
    },
    {
        name: 'pch_provider_business_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Proveedor',
        },
    },
    {
        name: 'pch_provider_branch_offices_address',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Sucursal',
        },
    },
    {
        name: 'pch_order_state_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Estado',
        },
    },
    {
        name: 'wh_warehouse_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Bodega',
        },
    },
    {
        name: 'originator_user_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Creada por',
        },
    },
    {
        name: 'authorizer_user_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Autorizado por',
        },
    },
    {
        name: 'authorization_date',
        type: 'date-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Fecha autorización',
        },
    },
    {
        name: 'pch_detail_purchase_orders',
        type: 'table-field',
        flex: {
            xs12: true,
            'd-grid': true,
        },
        props: {
            toolbarTitle: 'Detalle de productos de orden de compra',
            headers: [],
        },
    },
    // {
    //     flex: {
    //         sm8: true,
    //     },
    // },
    {
        name: 'iva',
        type: 'currency-field',
        flex: {
            'offset-xs6': true,
            sm3: true,
        },
        props: {
            label: 'IVA',
            reverse: true
        },
    },
    {
        name: 'net_subtotal',
        type: 'currency-field',
        flex: {
            sm3: true,
        },
        props: {
            label: 'Neto',
            reverse: true
        },
    },
    // {
    //     flex: {
    //         sm: 10,
    //     },
    // },
    {
        name: 'total',
        type: 'currency-field',
        flex: {
            'offset-xs9': true,
            sm3: true,
        },
        props: {
            label: 'Total',
            reverse: true
        },
    },
]
